import React from 'react';
import { CTAButton } from './ui/CTAButton';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 px-4 sm:px-6 lg:px-8 bg-[#FFF8F0] overflow-hidden" data-id="element-98">
      {/* Decorative background element */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-7xl h-full overflow-hidden pointer-events-none opacity-20" data-id="element-99">
        <div className="absolute -top-[20%] -right-[10%] w-[70%] h-[70%] rounded-full bg-gradient-to-br from-[#F59E0B] to-transparent blur-3xl" data-id="element-100" />
        <div className="absolute -bottom-[20%] -left-[10%] w-[60%] h-[60%] rounded-full bg-gradient-to-tr from-[#EA580C] to-transparent blur-3xl" data-id="element-101" />
      </div>

      <div className="relative max-w-5xl mx-auto text-center" data-id="element-102">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-103">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-black text-[#422006] leading-tight mb-6" data-id="element-104">
            Cenas Listas en 15 Minutos <br className="hidden md:block" data-id="element-105" />
            <span className="text-[#EA580C]" data-id="element-106">para Mamás Sin Tiempo</span>
          </h1>

          <h2 className="text-xl md:text-2xl font-bold text-[#78350F] mb-6 max-w-3xl mx-auto leading-snug" data-id="element-107">
            Transforma una Base en 3 Cenas Diferentes y Recupera Tus Noches
          </h2>

          <p className="text-lg md:text-xl text-[#78350F] mb-10 max-w-2xl mx-auto opacity-90" data-id="element-108">
            Más que recetas: un plan simple para mamás solteras que quieren
            cenar bien, sin estrés y sin repetición.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative mx-auto max-w-2xl mb-12" data-id="element-109">
          <div className="relative rounded-2xl overflow-hidden shadow-2xl border-4 border-white" data-id="element-110">
            <img src="https://cdn.magicpatterns.com/uploads/iEcnwY386cg4C5MYQQusZt/portada_4.png" alt="Menús Express - Ebook para mamás solteras" className="w-full h-auto object-cover" data-id="element-111" />
          </div>
          {/* Decorative floating badge */}
          <motion.div initial={{
          opacity: 0,
          rotate: -12,
          scale: 0.8
        }} animate={{
          opacity: 1,
          rotate: [-6, -3, -6],
          scale: [1, 1.08, 1]
        }} transition={{
          opacity: {
            duration: 0.5,
            delay: 0.5
          },
          rotate: {
            duration: 1.5,
            delay: 1,
            repeat: Infinity,
            repeatDelay: 2.5,
            ease: 'easeInOut'
          },
          scale: {
            duration: 1.5,
            delay: 1,
            repeat: Infinity,
            repeatDelay: 2.5,
            ease: 'easeInOut'
          }
        }} className="absolute -bottom-5 -right-5 md:-right-7 bg-[#EA580C] text-white rounded-full w-28 h-28 md:w-32 md:h-32 flex flex-col items-center justify-center shadow-xl border-4 border-white z-10 cursor-default" data-id="element-112">
            <span className="text-[10px] font-bold uppercase tracking-wider opacity-70 line-through decoration-white/80" data-id="element-113">
              $22 USD
            </span>
            <span className="text-[7px] font-black uppercase tracking-wider text-yellow-300 mt-0.5 leading-tight" data-id="element-114">
              Lanzamiento
            </span>
            <span className="text-2xl md:text-3xl font-black leading-none mt-0.5" data-id="element-115">
              $6.39
            </span>
          </motion.div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} data-id="element-116">
          <CTAButton data-id="element-117" />
          <p className="mt-4 text-sm font-medium text-[#78350F] opacity-80" data-id="element-118">
            Acceso inmediato. Formato optimizado para celular.
          </p>
          <p className="mt-2 text-xs text-[#78350F] opacity-60" data-id="element-119">
            🛡️ Garantía de satisfacción de 7 días — si no te convence, te
            devolvemos tu dinero.
          </p>
        </motion.div>
      </div>
    </section>;
}